import { faGlobe, faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@framework/ui/atoms/Tooltip';
import type { WorkspaceInternalPublicMemberRoleJSON } from 'balus-common';
import { useTranslation } from 'react-i18next';

type Props = {
  isPublicSpace: boolean;
  isPersonal: boolean;
  internalPublicSetting: WorkspaceInternalPublicMemberRoleJSON | null;
};

export const WorkspacePublicStatusIcon: React.FC<Props> = ({
  isPublicSpace,
  isPersonal,
  internalPublicSetting,
}: Props) => {
  const { t } = useTranslation();
  if (isPublicSpace) {
    return (
      <Tooltip tooltip={t('workspace.viewModelItem.publicBadge')} placement="bottom">
        <FontAwesomeIcon icon={faGlobe} />
      </Tooltip>
    );
  }

  // グループ内公開ワークスペース、または、パーソナルワークスペースの場合には、アイコンを表示しない
  if (internalPublicSetting || isPersonal) {
    return null;
  }

  return (
    <Tooltip tooltip={t('workspace.publicStatus.private')} placement="bottom">
      <FontAwesomeIcon icon={faLock} />
    </Tooltip>
  );
};
